module.exports = __webpack_public_path__ + "img/3.8ab1303a.jpg";